
(function () {
  if (window.__veeryColeccionVistas) return;
  window.__veeryColeccionVistas = true;

  var N = window.VeeryVistasNucleo;
  if (!N) return;

  var mq1200 = window.matchMedia('(min-width: 1200px)');
  var mqReducir = window.matchMedia('(prefers-reduced-motion: reduce)');

  function secciones() {
    return document.querySelectorAll('[data-vmc-vistas]');
  }

  function columnasEfectivas(sec) {
    var c = parseInt(sec.getAttribute('data-vmc-cols'), 10);
    return c === 6 && !mq1200.matches ? 4 : c;
  }

  function sincronizar(sec) {
    var vista = sec.getAttribute('data-vmc-vista') || 'rejilla';
    var bv = sec.querySelectorAll('[data-vmc-vista-btn]');
    for (var i = 0; i < bv.length; i++) {
      bv[i].setAttribute('aria-pressed', String(bv[i].getAttribute('data-vmc-vista-btn') === vista));
    }
    var cols = columnasEfectivas(sec);
    var bc = sec.querySelectorAll('[data-vmc-cols-btn]');
    for (var j = 0; j < bc.length; j++) {
      bc[j].setAttribute('aria-pressed', String(parseInt(bc[j].getAttribute('data-vmc-cols-btn'), 10) === cols));
    }
    N.ajustarSeccion(sec);
  }

  function sincronizarTodo() {
    var s = secciones();
    for (var i = 0; i < s.length; i++) sincronizar(s[i]);
  }

  function ponerVista(sec, vista) {
    N.guardar(N.CLAVE_VISTA, vista);
    if (sec.getAttribute('data-vmc-vista') === vista) return;
    sec.setAttribute('data-vmc-vista', vista);
    sincronizar(sec);
  }


  var turno = 0;
  var nombrados = [];

  function quitarNombres() {
    for (var i = 0; i < nombrados.length; i++) {
      nombrados[i].style.removeProperty('view-transition-name');
      nombrados[i].style.removeProperty('view-transition-class');
    }
    nombrados = [];
  }

  function nombrarVisibles(sec) {
    var alto = window.innerHeight || document.documentElement.clientHeight;
    var cartas = sec.querySelectorAll('.vmc__grid > [data-vmc-id]');
    for (var i = 0; i < cartas.length; i++) {
      var r = cartas[i].getBoundingClientRect();
      if (r.bottom <= 0 || r.top >= alto) continue;
      cartas[i].style.setProperty('view-transition-name', 'vmc-carta-' + cartas[i].getAttribute('data-vmc-id'));
      cartas[i].style.setProperty('view-transition-class', 'vmc-carta');
      nombrados.push(cartas[i]);
    }
  }

  function ponerColumnas(sec, n) {
    N.guardar(N.CLAVE_COLS, String(n));
    if (sec.getAttribute('data-vmc-cols') === String(n)) return;

    function cambiar() {
      sec.setAttribute('data-vmc-cols', String(n));
      sincronizar(sec);
    }

    var animar =
      typeof document.startViewTransition === 'function' &&
      !mqReducir.matches &&
      document.visibilityState === 'visible' &&
      sec.getAttribute('data-vmc-vista') !== 'indice';
    if (!animar) {
      cambiar();
      return;
    }

    var miTurno = ++turno;
    quitarNombres();
    nombrarVisibles(sec);
    var limpiar = function () {
      if (miTurno === turno) quitarNombres();
    };
    try {
      var t = document.startViewTransition(cambiar);
      t.finished.then(limpiar, limpiar);
      if (t.ready) t.ready.catch(function () {});
    } catch (e) {
      limpiar();
      cambiar();
    }
  }


  document.addEventListener('click', function (e) {
    var destino = e.target;
    if (!destino || !destino.closest) return;

    var bVista = destino.closest('[data-vmc-vista-btn]');
    if (bVista) {
      var s1 = bVista.closest('[data-vmc-vistas]');
      if (s1) ponerVista(s1, bVista.getAttribute('data-vmc-vista-btn') === 'indice' ? 'indice' : 'rejilla');
      return;
    }

    var bCols = destino.closest('[data-vmc-cols-btn]');
    if (bCols) {
      var s2 = bCols.closest('[data-vmc-vistas]');
      var n = parseInt(bCols.getAttribute('data-vmc-cols-btn'), 10);
      if (s2 && (n === 3 || n === 4 || n === 6)) ponerColumnas(s2, n);
      return;
    }

    var fila = destino.closest('[data-vmc-fila]');
    if (!fila || e.defaultPrevented || e.button !== 0) return;
    if (destino.closest('a, button, input, select, textarea, label')) return;
    if (window.getSelection && String(window.getSelection())) return;
    var enlace = fila.querySelector('a[href]');
    if (!enlace) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) {
      window.open(enlace.href, '_blank', 'noopener');
      return;
    }
    enlace.click();
  });

  if (mq1200.addEventListener) mq1200.addEventListener('change', sincronizarTodo);
  else if (mq1200.addListener) mq1200.addListener(sincronizarTodo);

  window.VeeryColeccionVistas = { sincronizar: sincronizarTodo };
  sincronizarTodo();
})();
